import { Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import { Title, useTranslate } from 'react-admin'
import { useLocation, useNavigate } from 'react-router-dom'

import { isHiddenKey, readHiddenKey, storeHiddenKey } from '@/lib/hiddenKey'

import { type CountLabel, SourceReadPanel } from '../molecules/SourceReadPanel'

const AIS_COUNTS: CountLabel[] = [
  { name: 'stays.opened', label: 'pages.hidden.ais.counts.opened' },
  { name: 'stays.closed', label: 'pages.hidden.ais.counts.closed' },
  { name: 'checks.written', label: 'pages.hidden.ais.counts.written' },
]

export const HiddenPage = () => {
  const translate = useTranslate()
  const navigate = useNavigate()
  const location = useLocation()
  const [keyInUrl] = useState(() => new URLSearchParams(location.search).get('key'))
  const [unlocked, setUnlocked] = useState(false)

  useEffect(() => {
    if (keyInUrl !== null) void navigate('/hidden', { replace: true })
    const run = { cancelled: false }
    const configured: unknown = import.meta.env.VITE_HIDDEN_KEY_SHA256
    const expected = typeof configured === 'string' ? configured : undefined
    const check = async () => {
      if (keyInUrl !== null && (await isHiddenKey(keyInUrl, expected))) {
        storeHiddenKey(keyInUrl)
        return true
      }
      const stored = readHiddenKey()
      return stored !== null && isHiddenKey(stored, expected)
    }
    void (async () => {
      const ok = await check()
      if (!run.cancelled) setUnlocked(ok)
    })()
    return () => {
      run.cancelled = true
    }
  }, [keyInUrl, navigate])

  if (!unlocked) return null
  return (
    <Stack p={2} spacing={2}>
      <Title title={translate('pages.hidden.title')} />
      <SourceReadPanel source="SOSTRAT" />
      <SourceReadPanel source="AIS" countLabels={AIS_COUNTS} />
    </Stack>
  )
}
